export default class SliderNav {
	constructor(element) {
		 this.element = element;
		 const slider = document.querySelector('.slider');
		 const prevButton = document.querySelector('.slider__prev');
		 const nextButton = document.querySelector('.slider__next');
		 let currentIndex = 0;

		 let slideWidth = window.innerWidth * 0.35 + 32;

		 const setSlideWidth = () => {
			  if (window.matchMedia('(min-width: 56.25em)').matches) {
					slideWidth = window.innerWidth * 0.35 + 32;
			  } else {
					slideWidth = window.innerWidth * 0.6 + 16;
			  }
		 };

		 setSlideWidth();

		 function showSlide(index) {
			  slider.style.transform = `translateX(-${index * slideWidth}px)`;
			  updateButtons(index);
		 }

		 function prevSlide() {
			  currentIndex = Math.max(currentIndex - 1, 0);
			  showSlide(currentIndex);
		 }

		 function nextSlide() {
			  const slides = document.querySelectorAll('.slider-item');
			  currentIndex = Math.min(currentIndex + 1, slides.length - 1);
			  showSlide(currentIndex);
		 }

		 function updateButtons(index) {
			  if (index === 0) {
					prevButton.classList.add('disabled');
			  } else {
					prevButton.classList.remove('disabled');
			  }

			  const slides = document.querySelectorAll('.slider-item');
			  if (index === slides.length - 1) {
					nextButton.classList.add('disabled');
			  } else {
					nextButton.classList.remove('disabled');
			  }
		 }

		 prevButton.addEventListener('click', prevSlide);
		 nextButton.addEventListener('click', nextSlide);

		 let touchStartX = 0;
		 let touchEndX = 0;

		 slider.addEventListener('touchstart', (e) => {
			  touchStartX = e.touches[0].clientX;
		 });

		 slider.addEventListener('touchend', (e) => {
			  touchEndX = e.changedTouches[0].clientX;
			  if (touchStartX - touchEndX > 50) {
					nextSlide();
			  } else if (touchEndX - touchStartX > 50) {
					prevSlide();
			  }
		 });

		 showSlide(currentIndex);
	}
}
